import { FC, useContext } from 'react';
import { Box } from '@chakra-ui/react';
import InfolinoContext from '../../../context/InfolinoContext';
import RatingForm from '../../Node/Hotel/Forms/RatingForm';

type InfolinoRatingProps = {};

const InfolinoRating: FC<InfolinoRatingProps> = () => {
  const infolinoContext = useContext(InfolinoContext);

  return (
    <Box>
      <RatingForm
        hotelId={infolinoContext.hotel?.id}
        isOpen={true}
        onClose={() => null}
        inline
      />
    </Box>
  );
};

export default InfolinoRating;
